import { getISODateString } from '../../utils/utils';
import * as Style from '../Sidebar/style';

function FilterMessageDates({ messagesDateBounds, setMessagesByDate }) {
  return (
    <Style.Form onSubmit={setMessagesByDate}>
      <Style.Fieldset>
        <legend>Messages date window</legend>
        <Style.Field>
          <Style.Label htmlFor="start-date">Start</Style.Label>
          <Style.Input
            id="start-date"
            name="startDate"
            type="date"
            min={getISODateString(messagesDateBounds.start)}
            max={getISODateString(messagesDateBounds.end)}
            defaultValue={getISODateString(messagesDateBounds.start)}
          />
        </Style.Field>
        <Style.Field>
          <Style.Label htmlFor="end-date">End</Style.Label>
          <Style.Input
            id="end-date"
            name="endDate"
            type="date"
            min={getISODateString(messagesDateBounds.start)}
            max={getISODateString(messagesDateBounds.end)}
            defaultValue={getISODateString(messagesDateBounds.end)}
          />
        </Style.Field>
        <Style.Field>
          <Style.Submit type="submit" value="Apply" />
          <Style.InputDescription>
            A high delta may freeze the page for a while, change this with
            caution
          </Style.InputDescription>
        </Style.Field>
      </Style.Fieldset>
    </Style.Form>
  );
}

export default FilterMessageDates;
